import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import Works from './components/Works';
import PlayList from './components/PlayList';
import Achievements from './components/Achievements';
import Profile from './components/Profile';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-warm-ivory">
      <Navbar />
      <Hero />
      <Works />
      <PlayList />
      <Achievements />
      <Profile />
      <Contact />
      <Footer />
    </main>
  );
}